import { request } from '../request'
import { Customer, CustomerMeta } from '../types'

export class CustomersService {

  getCustomers(): Promise<Customer[]> {
    return request.get('/api/customers.json')
  }

  getCustomer(id: number): Promise<Customer> {
    return request.get(`/api/customers/${id}.json`)
  }

  updateCustomer(id: number, updates: object): Promise<any> {
    return request.put(`/api/customers/${id}.json`, { customer: updates })
  }

  createCustomer(body: object): Promise<Customer> {
    return request.post(`/api/customers.json`, { customer: body })
  }

  removeCustomer(id: number): Promise<any> {
    return request.del(`/api/customers/${id}.json`)
  }

  getMetadata(id: number): Promise<CustomerMeta> {
    return request.get(`/api/customers/${id}/metadata.json`)
  }

  requestKeywords(id: number): Promise<any> {
    return request.put(`/api/customers/${id}/request_keywords.json`)
  }

}
